<div class="inbox">
  <h1 class="inbox__title">Messages</h1>

  <div class="inbox__card" *ngIf="!selected">
    <div class="inbox__head">
      <span class="inbox__head-title">Inbox <span class="inbox__badge" *ngIf="unreadCount > 0">{{ unreadCount }} unread</span></span>
      <div class="inbox__tools">
        <mat-checkbox [checked]="allChecked" [indeterminate]="checked.size > 0 && !allChecked"
                      (change)="toggleAll($event.checked)" aria-label="Select all"></mat-checkbox>
        <button mat-button class="inbox__delete" [disabled]="checked.size === 0" (click)="removeChecked()">
          <mat-icon>delete_outline</mat-icon> Delete
        </button>
      </div>
    </div>

    <div *ngIf="loading" class="inbox__muted">Loading…</div>
    <div *ngIf="!loading && messages.length === 0" class="inbox__empty">
      <mat-icon>inbox</mat-icon>
      <p>You have no messages.</p>
    </div>

    <ul class="inbox__list" *ngIf="!loading && messages.length > 0">
      <li *ngFor="let m of messages" class="inbox__item" [class.inbox__item--unread]="!m.read" (click)="open(m)">
        <mat-checkbox class="inbox__check" [checked]="checked.has(m.id)" (click)="$event.stopPropagation()"
                      (change)="toggle(m, $event.checked)" [attr.aria-label]="'Select ' + m.subject"></mat-checkbox>
        <div class="inbox__item-body">
          <span class="inbox__sender">{{ m.sender }}</span>
          <span class="inbox__subject">{{ m.subject }}</span>
          <span class="inbox__preview">{{ preview(m) }} <mat-icon class="inbox__clip" *ngIf="m.attachments?.length" inline>attach_file</mat-icon></span>
        </div>
        <div class="inbox__item-side">
          <button mat-icon-button class="inbox__trash" (click)="remove(m, $event)" aria-label="Delete message">
            <mat-icon>delete_outline</mat-icon>
          </button>
          <span class="inbox__when">{{ when(m) }}</span>
        </div>
      </li>
    </ul>
  </div>

  <div class="inbox__card inbox__detail" *ngIf="selected as s">
    <button mat-button class="inbox__back" (click)="back()"><mat-icon>arrow_back</mat-icon> Inbox</button>
    <span class="inbox__sender">{{ s.sender }}</span>
    <h2>{{ s.subject }}</h2>
    <p class="inbox__muted">{{ s.createdAt | date:'MMM d, yyyy h:mm a' }}</p>
    <div class="inbox__text inbox__text--html" *ngIf="s.html" [innerHTML]="s.body"></div>
    <p class="inbox__text" *ngIf="!s.html">{{ s.body }}</p>
    <div class="inbox__files" *ngIf="s.attachments?.length">
      <div class="inbox__files-title"><mat-icon>attach_file</mat-icon> Attachments</div>
      <a *ngFor="let f of s.attachments" class="inbox__file" [href]="f.url" target="_blank" rel="noopener">
        <mat-icon>description</mat-icon> {{ f.fileName }} <small>{{ size(f.fileSize) }}</small>
      </a>
    </div>
    <button mat-stroked-button color="warn" (click)="remove(s)"><mat-icon>delete_outline</mat-icon> Delete</button>
  </div>
</div>
